module.exports = __webpack_public_path__ + "static/media/unicorn.26be210c.svg";